export class CaseSheetParams {
    fromDate: string;
    toDate: string;
    caseCategory: string;
  
    constructor(fromDate: string, toDate: string, caseCategory: string) {
      this.fromDate = fromDate;
      this.toDate = toDate;
      this.caseCategory = caseCategory;
    }
}

export class CaseRecord {
  caseId: number;
  caseNumber: string;
  appellantsParty: string;
  respondentsParty: string;
  documentStatus: string;
  fromDate: string;
  toDate: string;
  caseCategory: string;
  auditMessage: string;

  constructor(
    caseId: number,
    caseNumber: string,
    appellantsParty: string,
    respondentsParty: string,
    documentStatus: string,
    fromDate: string,
    toDate: string,
    caseCategory: string,
    auditMessage: string
  ) {
    this.caseId = caseId;
    this.caseNumber = caseNumber;
    this.appellantsParty = appellantsParty;
    this.respondentsParty = respondentsParty;
    this.documentStatus = documentStatus;
    this.fromDate = fromDate;
    this.toDate = toDate;
    this.caseCategory = caseCategory;
    this.auditMessage = auditMessage;
  }
}

export class CaseSheetResponse {
  data: CaseRecord[];
  totalCount: number;

  constructor(data: CaseRecord[], totalCount: number) {
    this.data = data;
    this.totalCount = totalCount;
  }
}


  